import { SalesforceObjectType } from 'constants/salesforce'

export const CREATE_LEAD_FROM_NEWSLETTER_ROUTE = '/salesforce/lead/newsletter'
export const PATIENT_REFERRALS = 'salesforce/referrals'
export const RETRY_REFERRAL = (id: string): string =>
  `salesforce/referral/${id}/retry`

export const getLeadRoute = (id: string): string => `/salesforce/lead/${id}`

export const getCaseRoute = (id: string): string => `/salesforce/case/${id}`

export const getSfApiRoute = (
  id: string,
  sfObjectType: SalesforceObjectType
): string => `/salesforce/${sfObjectType}/${id}`
